// extracted by mini-css-extract-plugin
export default {"contentContainer":"styles-module__contentContainer__src-labstep-web-components-File-CollapsibleCard-_j7bIc"};